export default "__VITE_ASSET__DtIlRbI8__"